
































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import DealOfferListComponent from '@/components/DealOfferListComponent.vue';                       // @ is an alias to /src
import * as utils_tracker from '@/utils_tracker';
import * as utils_topshot from '@/utils_topshot';
import { DealOffer } from '@/DealOffer'
import { Challenge } from '@/Challenge'
import { TokenUser } from '@/TokenUser'
import { io, Socket } from "socket.io-client";
import MomentSelectorAndSorterComponent from '@/components/MomentSelectorAndSorterComponent.vue';                       // @ is an alias to /src
import { AdvancedSearch } from '@/Moment' 
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

let USE_SOCKET_IO: boolean = false
const STOP_AFTER_X_CONSECUTIVE_ERRORS: number = 2

@Component({
  name: 'LiveOfferDeals',
  components: { DealOfferListComponent, MomentSelectorAndSorterComponent, ModalWrapperComponent }
})

export default class LiveDealsComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public deals: DealOffer[] = []
  public advancedSearchStringUsed: string = null
  private playerID: number = null
  private setID: number = null
  private playID: number = null

  // UI and filter options
  public minDealRatings: Array<{ label: string, minRating: number }> = [
    { label: 'Show +', minRating: 0.5 },
    { label: '🏀+', minRating: 1 },
    { label: '🏀🏀+', minRating: 2 },
    { label: '🏀🏀🏀+', minRating: 3 },
    { label: '🏀🏀🏀🏀+', minRating: 4 },
    { label: '🏀🏀🏀🏀🏀', minRating: 5 },
  ]
  public minDealRating: { label: string, minRating: number } = this.minDealRatings[1]

  public minDealAudios: Array<{ label: string, minRating: number }> = [
    { label: 'Silence', minRating: -1 },
    { label: 'Ding +', minRating: 0.5 },
    { label: 'Ding 🏀+', minRating: 1 },
    { label: 'Ding 🏀🏀+', minRating: 2 },
    { label: 'Ding 🏀🏀🏀+', minRating: 3 },
    { label: 'Ding 🏀🏀🏀🏀+', minRating: 4 },
    { label: 'Ding 🏀🏀🏀🏀🏀', minRating: 5 },
  ]
  public minDealAudio: { label: string, minRating: number } = this.minDealAudios[0]

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public showFAQ(): void {
    (this.$refs.FAQOfferDealsComponent as ModalWrapperComponent).show('Live Offers FAQ', 'md', null)
  }

  @Watch('minDealRating')
  public async onChangedMinDealRating(minDealRating: { label: string, minRating: number }) {
    this.minDealRating = minDealRating ? minDealRating : this.minDealRatings[1]
    utils_topshot.setPreferredDealOfferRating(this.minDealRating)
    this.deals = []
    await this.fetchData(false)
    if (this.isConnectedBySocket) {
      // join the appropriate room (server will handle leaving old rooms)
      this.socket.emit('joinOfferDealRoom', `dealOffers${this.minDealRating.minRating}`, this.user && this.user._temp.account ? this.user._temp.account.username : null , this.userId ? this.userId : null )
    }
  }
  @Watch('minDealAudio')
  public async onChangedMinDealAudio(minDealAudio: { label: string, minRating: number }) {
    this.minDealAudio = minDealAudio ? minDealAudio : this.minDealAudios[0]
    if (this.minDealAudio.minRating > 0 && this.minDealAudio.minRating < this.minDealRating.minRating) {
      this.onChangedMinDealRating(this.minDealRatings[Math.floor(this.minDealAudio.minRating)])
    }
    if (this.minDealAudio.minRating > 0) this.ding()
    utils_topshot.setPreferredDealOfferAudio(this.minDealAudio)
  }

  public async onChangedPSD(player: { label: string, playerID: number }, set: { label: string, setID: number }, duo: { label: string, setID: number, playID: number }) {
    this.playerID = player.playerID
    this.setID = duo.setID || set.setID

    if (!this.playID && duo.playID) {
      this.playID = duo.playID
    } else {
       this.playID = duo.playID
    }

    this.deals = []
    await this.fetchData(false)
  }  

  public async onChangedAdvanced(advancedSearch: AdvancedSearch) {
    if (advancedSearch) this.advancedSearchStringUsed = JSON.stringify(advancedSearch)
    else this.advancedSearchStringUsed = null

    this.deals = []
    await this.fetchData(false)
  }  

  public ding() {
    if (this.dingSound) this.dingSound.play();
  }

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean = true
  private timerFetch
  private timerUpdateTimeAgo
  private numErrorsInARow: number = 0
  private socket: Socket = null
  private numConnectionErrors: number = 0
  private isConnectedBySocket: boolean
  private dingSound: HTMLAudioElement
  private isFetching: boolean = false

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`LiveOfferDeals.pathChanged() ${this.$route.path}`)

    if (!USE_SOCKET_IO) await this.fetchData(false)
  }

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    // partial rollout to people based on their unique clientid
    const ucid: number = utils.getAndSetUniqueClientID()
    // USE_SOCKET_IO = utils_topshot.getBubbaMode() || utils_topshot.getFastPolling() || ucid % 5 === 0     // 5% at first => 10% => 20%
    USE_SOCKET_IO = true    // try going for 100%

    // restore your favorite deal settings
    const savedMinDealRating: { label: string, minRating: number } = utils_topshot.getPreferredDealOfferRating()
    if (savedMinDealRating != null) this.minDealRating = savedMinDealRating
    const savedMinAudioRating: { label: string, minRating: number } = utils_topshot.getPreferredDealOfferAudio()
    if (savedMinAudioRating != null) this.minDealAudio = savedMinAudioRating

    await this.pathChanged()

    // if we end up connecting by socket, then don't do the fetch
    this.timerFetch = setInterval(function() {
      if (this.isConnectedBySocket) return
      if (this.lastFetchSucceeded || this.numErrorsInARow < STOP_AFTER_X_CONSECUTIVE_ERRORS) {
        this.fetchData(true)
      }
    }.bind(this), 3000)

    if (USE_SOCKET_IO) this.connectSocket()

    // if (new Date() < new Date('11-15-2022')) utils.showTopAlert('success', "__ ____ ____.", null)

    this.dingSound = new Audio('/sounds/ding.mp3')

  }
  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)

    if (this.timerFetch) clearTimeout(this.timerFetch)
    this.timerFetch = null

    if (this.socket && this.isConnectedBySocket) {
      this.socket.emit('leaveRoom', `dealOffers${this.minDealRating.minRating}`, this.user && this.user._temp.account ? this.user._temp.account.username : null, this.userId ? this.userId : null )
      this.socket.disconnect()
    }
    this.socket = null
  }

  // https://socket.io/docs/v4/client-socket-instance/
  private connectSocket() {
    try {
      // https://socket.io/docs/v3/using-multiple-nodes/
      this.socket = io(utils.getURLprefix(), { autoConnect: true, transports: [ "websocket" ] });   // it was very important to not allow polling 

      // for debugging
      if (this.$store.state.devmode) {
        this.socket.onAny((event, ...args) => {
          console.log(event, args);
        });
      }

      // handle a new deal coming in
      this.socket.on("newOfferDeal", (po: object) => {
        const deal: DealOffer = new DealOffer(po)

        let passesFilters: boolean = true

        // filter by PSD
        if (this.playerID && deal.playerID !== this.playerID) passesFilters = false
        if (this.setID && deal.setID !== this.setID) passesFilters = false
        if (this.playID && deal.playID !== this.playID) passesFilters = false

        // filter by advanced search
        if (this.advancedSearchStringUsed) {
          const advSearch: AdvancedSearch = JSON.parse(this.advancedSearchStringUsed)

          if (advSearch.league === 'NBA' && deal.getTeamAbbreviation().startsWith('W-')) passesFilters = false
          if (advSearch.league === 'WNBA' && !deal.getTeamAbbreviation().startsWith('W-')) passesFilters = false

          if (advSearch.team && advSearch.team !== deal.team) passesFilters = false
          if (advSearch.playCategory && advSearch.playCategory !== deal.playCategory) passesFilters = false
          if (advSearch.minPrice && deal.offerPrice < advSearch.minPrice) passesFilters = false
          if (advSearch.maxPrice && deal.offerPrice > advSearch.maxPrice) passesFilters = false
          if (advSearch.minFMV && deal.valueFMV < advSearch.minFMV) passesFilters = false
          if (advSearch.maxFMV && deal.valueFMV > advSearch.maxFMV) passesFilters = false
          if (advSearch.minSerial && deal.serialNumber < advSearch.minSerial) passesFilters = false
          if (advSearch.maxSerial && deal.serialNumber > advSearch.maxSerial) passesFilters = false
          const discountPercentage =  (deal.valueFMV - deal.offerPrice) / deal.valueFMV
          if (advSearch.minDiscount && discountPercentage < advSearch.minDiscount) passesFilters = false
          if (advSearch.jersey && !deal.isJerseyNumber) passesFilters = false
          if (advSearch.lastMint && !deal.isMaxSerial) passesFilters = false
          if (advSearch.neverSold && deal.numTimesSold > 0) passesFilters = false
          if (advSearch.tsdebut && !deal.isFirstMoment) passesFilters = false
          if (advSearch.rookieYear && !deal.isRookieMoment) passesFilters = false
          if (advSearch.rookieMint && !deal.isRookieMint) passesFilters = false
          if (advSearch.rookiePremiere && !deal.isRookieDebut) passesFilters = false
          if (advSearch.champYear && !deal.isChampionshipYear) passesFilters = false
          if (advSearch.challengeReward && !deal.isChallengeReward) passesFilters = false
          if (advSearch.craftingChallengeReward && !deal.isCraftingChallengeReward) passesFilters = false
          if (advSearch.rarity && deal.setVisualId !== utils_topshot.convertRarityToSetVisualId(advSearch.rarity)) passesFilters = false
          if (advSearch.series !== null && advSearch.series !== undefined && deal.series !== advSearch.series) passesFilters = false      // May 16, 2024

        }

        if (passesFilters) {
          if (deal.dealRating >= this.minDealRating.minRating) this.deals.splice(1, 0, deal)
          if (this.deals.length > 100) this.deals.length = 100
          if (this.minDealAudio.minRating > 0 && deal.dealRating >= this.minDealAudio.minRating) this.ding()
        }
      });
      // handle a deal going gone
      this.socket.on("dealOfferGone", (po: object) => {
        const deal: DealOffer = new DealOffer(po)
        for (const existingDeal of this.deals) {
          if (deal.offerID === existingDeal.offerID) {
            existingDeal.gone = true
            break
          }
        }
      });

      // This event is fired by the Socket instance upon connection and reconnection
      this.socket.on("connect", async () => {
        if (this.$store.state.devmode) console.log(`${new Date().toLocaleString()}: Socket ${this.socket.id} connected`)
        await this.fetchData(false)
        if (this.socket) {
          this.isConnectedBySocket = true
          this.socket.emit('joinOfferDealRoom', `dealOffers${this.minDealRating.minRating}`, this.user && this.user._temp.account ? this.user._temp.account.username : null , this.userId ? this.userId : null )
        }
      });
      this.socket.on("connect_error", async () => {
        this.numConnectionErrors++
        if (this.$store.state.devmode) console.log(`${new Date().toLocaleString()}: Socket ${this.socket.id} got connect_error. Waiting ${this.numConnectionErrors}s before attempting reconnect`)
        await utils.sleep(this.numConnectionErrors * 1000)
        this.isConnectedBySocket = false
        if (this.socket) this.socket.connect();
      });
      this.socket.on("disconnect", (reason: string) => {
        this.isConnectedBySocket = false

        // not sure why every so often we get - "Socket undefined disconnected with reason: transport close"
        if (this.$store.state.devmode) console.log(`${new Date().toLocaleString()}: Socket ${this.socket.id} disconnected with reason: ${reason}`)

        if (reason === "io server disconnect") {
          // the disconnection was initiated by the server, so you need to reconnect manually (other forms of disconnect will auto reconnect)
          // if (this.$store.state.devmode || utils_topshot.getBubbaMode()) console.log(`${new Date().toLocaleString()}: Atempting manual reconnect because reason was ${reason}`)
          if (this.socket) this.socket.connect();
        }

      });

    } catch (e) {

    }


  }

  private async fetchData(autoFetch: boolean): Promise<void> {
    if (autoFetch && this.isFetching) return 

    const fakeMoment: DealOffer = new DealOffer(null)
    fakeMoment.offerID = 0
    fakeMoment.valueFMV = 0

    this.lastFetchSucceeded = false

    if (!autoFetch) this.$store.commit('setLoading', { loading: true });
    this.isFetching = true
    try {
      let url: string = utils.getURLprefix() + `/api/topshot/offerDeals?autoFetch=${autoFetch}`
      url += `&minDealRating=${this.minDealRating.minRating}`
      if (this.socket && this.isConnectedBySocket) url += `&socketId=${this.socket.id}`     // not sure server really cares, but oh well

      // March 22, 2022
      if (this.playerID) url += `&playerID=${this.playerID}`
      if (this.setID) url += `&setID=${this.setID}`
      if (this.playID) url += `&playID=${this.playID}`
      if (this.advancedSearchStringUsed) url += `&advancedSearch=${encodeURIComponent(this.advancedSearchStringUsed)}`

      const response: any = await utils.makeGetCall(url);

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        this.isFetching = false
        return;
      }

      // error check
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        this.numErrorsInARow++
        if (this.numErrorsInARow >= STOP_AFTER_X_CONSECUTIVE_ERRORS) utils.toast(this, 'Error', response.data.error)
        this.isFetching = false
        return
      }

      // moments
      if (response.data.deals) {
        this.deals = [ fakeMoment ].concat(response.data.deals.map((d) => new DealOffer(d)))
      }

      // for now, filter by liquidity here on the client side, but TODO is to have server possibly do it
      //  server now does it
      // this.deals = this.deals.filter((d) => d.momentID === 0 || d.liquidityRating >= this.minLiquidityRating.minRating)

      this.lastFetchSucceeded = true
      this.numErrorsInARow = 0

    } catch (error) {
      if (this.$store.state.devmode) console.log(error);
      this.numErrorsInARow++
      if (this.numErrorsInARow >= STOP_AFTER_X_CONSECUTIVE_ERRORS) if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
    }

    this.$store.commit("setLoading", { loading: false });
    this.isFetching = false

  }  
}
